import React from "react";

const FilesIcon: React.FC = () => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="24.5"
        cy="24"
        r="23.7"
        fill="#D2EEFF"
        stroke="#D4D6D9"
        strokeWidth="0.6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.1681 35.6673H20.1683C18.8421 35.6673 17.5703 35.1405 16.6325 34.2028C15.6948 33.265 15.168 31.9932 15.168 30.667V17.3343C15.168 16.0081 15.6948 14.7363 16.6325 13.7985C17.5703 12.8608 18.8421 12.334 20.1683 12.334H24.8443C25.8331 12.3342 26.7882 12.6932 27.5323 13.3443L31.7731 17.0543C32.2115 17.4376 32.5627 17.9102 32.8034 18.4404C33.044 18.9707 33.1685 19.5462 33.1685 20.1285V30.667C33.1685 31.3236 33.0391 31.9739 32.7878 32.5805C32.5366 33.1872 32.1682 33.7384 31.7039 34.2028C31.2396 34.6671 30.6884 35.0354 30.0817 35.2867C29.475 35.538 28.8248 35.6673 28.1681 35.6673ZM28.1681 33.334H20.1683C19.8181 33.334 19.4713 33.265 19.1477 33.131C18.8241 32.9969 18.5301 32.8005 18.2824 32.5528C18.0348 32.3052 17.8383 32.0112 17.7043 31.6876C17.5703 31.364 17.5013 31.0172 17.5013 30.667V17.3343C17.5013 16.627 17.7823 15.9486 18.2824 15.4485C18.7826 14.9483 19.461 14.6673 20.1683 14.6673H24.8443C25.2679 14.6675 25.677 14.8213 25.9958 15.1002L30.2366 18.8102C30.4247 18.9745 30.5754 19.1771 30.6786 19.4045C30.7818 19.6319 30.8352 19.8788 30.8351 20.1285V30.667C30.8351 31.0172 30.7662 31.364 30.6321 31.6876C30.4981 32.0112 30.3016 32.3052 30.054 32.5528C29.8063 32.8005 29.5123 32.9969 29.1888 33.131C28.8652 33.265 28.5184 33.334 28.1681 33.334Z"
        fill="#DDB100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6667 13.5C25.9761 13.5 26.2728 13.6229 26.4916 13.8417C26.7104 14.0605 26.8333 14.3572 26.8333 14.6667V18.1667C26.8333 18.4761 26.9562 18.7728 27.175 18.9916C27.3938 19.2104 27.6906 19.3333 28 19.3333H30.9167C31.2261 19.3333 31.5228 19.4563 31.7416 19.675C31.9604 19.8938 32.0833 20.1906 32.0833 20.5C32.0833 20.8094 31.9604 21.1062 31.7416 21.325C31.5228 21.5438 31.2261 21.6667 30.9167 21.6667H28C27.0717 21.6667 26.1815 21.2979 25.5251 20.6415C24.8687 19.9852 24.5 19.0949 24.5 18.1667V14.6667C24.5 14.3572 24.6229 14.0605 24.8417 13.8417C25.0605 13.6229 25.3572 13.5 25.6667 13.5Z"
        fill="#DDB100"
      />
    </svg>
  );
};

export default FilesIcon;
